import {PHONE_EMAIL, WEBSITE_URL_REGEX} from "../constants";
import {manualFileUploaded} from "../preview_uploaded_file";

window.NewCompanyDetails = {
    init() {
        this.handleAnalytics();
        this.initSummernote();
        this.validateCompanyDetailsForm();
        this.handleChangeEvents();
        this.handleClickEvents();
        this.showToolbar();
    },

    handleAnalytics() {
        const setupAnalytics = () => {
            window.analytics.page("", ANALYTICS_EVENTS.CREATE_COMPANY_PAGE_VIEWED);

            const finishButton = document.getElementById("finish-btn");
            finishButton.addEventListener("click", () => {
                const companyDetailsForm = document.getElementById("company-details-form");
                window.analytics.track(ANALYTICS_EVENTS.COMPANY_INFO_SUBMITTED, {
                    logo_uploaded: !!companyDetailsForm.elements["company[company_detail_attributes][logo]"].value,
                    company_name: companyDetailsForm.elements["company[name]"].value,
                    company_website: companyDetailsForm.elements["company[company_detail_attributes][website_url]"].value,
                    supply_to_large_buyers: companyDetailsForm.elements["company[company_detail_attributes][supply_to_large_buyers]"].value,
                    num_buyers_supplied: companyDetailsForm.elements["company[company_detail_attributes][supply_count]"].value
                })
            });
        };

        if (window.analytics) {
            setupAnalytics();
        } else {
            document.addEventListener('analyticsReady', setupAnalytics, {once: true});
        }
    },

    initSummernote() {
        $('#company-detail__description-text').summernote({
            minHeight: 200,
            focus: false,
            airMode: false,
            fontNames: ['Montserrat'],
            fontNamesIgnoreCheck: ['Montserrat'],
            fontSizeUnits: ['pt'],
            dialogsInBody: true,
            dialogsFade: true,
            disableDragAndDrop: true,
            toolbar: [
                ['style', ['bold', 'italic', 'clear']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['misc', ['undo', 'redo']]
            ],
            popover: {
                air: [
                    ['color', ['color']],
                    ['font', ['bold', 'clear']]
                ]
            },
            callbacks: {
                onInit: function () {
                    const $editor = $(this).siblings('.note-editor');
                    const $charCount = $('#company-detail__character-count');
                    $editor.find('.note-editing-area').append($charCount);
                },
                onBlur: () => {
                    $('#hidden-field').trigger('input');
                    $('#hidden-field').valid();
                }
            }
        })
            .on('summernote.change', function (customEvent, contents, $editable) {
                document.getElementById('hidden-field').value = $editable[0].innerText
                const companyDetailCharacterCount = document.getElementById('company-detail__character-count');
                companyDetailCharacterCount.textContent = document.getElementById('hidden-field').value.length;
            });

        $('.note-editing-area').popover({
            content: "This information will be displayed on your Profile Page - we suggest you provide details of your company's background, industry and product range",
            trigger: "hover",
            class: "company-private-info",
            placement: "bottom",
            template: '<div class="popover company-private-popover"><div class="arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>'
        });
    },

    validateCompanyDetailsForm() {
        $("#company-details-form").validate({
            onsubmit: true,
            onkeyup: false,
            onclick: true,
            rules: {
                "company[name]": {
                    required: true,
                    minlength: 2,
                    maxlength: 100,
                },
                "company[company_detail_attributes][website_url]": {
                    required: true,
                    websiteUrl: true,
                },
                "hidden-field-name": {
                    required: true,
                    minlength: 100,
                    phoneUrl: true,
                },
                "company[company_detail_attributes][country_id]": {
                    required: true,
                    optionSelected: true,
                },
                "company[company_detail_attributes][range_of_inception]": {
                    required: true,
                    optionSelected: true,
                },
                "company[company_detail_attributes][number_of_employees]": {
                    required: true,
                    optionSelected: true,
                },
                "company[company_detail_attributes][yearly_turnover]": {
                    required: true,
                    optionSelected: true,
                },
                "company[company_detail_attributes][supply_to_large_buyers]": {
                    required: true,
                }
            },
            errorPlacement: (error, element) => {
                if ((element.attr('name') === 'hidden-field-name') ||
                    (element.attr('name') === 'company[company_detail_attributes][supply_to_large_buyers]')) {
                    error.insertAfter(element.parent());
                } else {
                    error.insertAfter(element);
                }
            },
            onfocusout: function (element) {
                $(element).val($.trim($(element).val()));
                return $(element).valid();
            }
        });

        $.validator.addMethod('optionSelected', function (value) {
            return value !== -1;
        }, 'Please select an option');

        $.validator.addMethod('websiteUrl', function (value) {
            return WEBSITE_URL_REGEX.test(value);
        }, 'Please enter a valid website');

        $.validator.addMethod('phoneUrl', function (value) {
            return !PHONE_EMAIL.test(value);
        }, 'Sorry, our system has identified contact details in your description, which are not allowed here, please edit your description to proceed - thank you');
    },

    handleChangeEvents() {
        $('#logo-uploader').change((event) => manualFileUploaded(event, '#logo-reviewer'));
    },

    handleClickEvents() {
        $('#logo-uploader-btn').click(function () {
            const logoUploader = document.getElementById('logo-uploader');
            logoUploader.click();
        })

        $('#yes-radio').click(function () {
            if ($('#yes-radio').prop('checked')) {
                $('.supply-dropdown').removeClass('hidden');
            } else {
                $('.supply-dropdown').addClass('hidden');
            }
        });

        $('#no-radio').click(function () {
            if ($('#no-radio').prop('checked')) {
                $('.supply-dropdown').addClass('hidden');
            } else {
                $('.supply-dropdown').removeClass('hidden');
            }
        });

        $('#finish-btn').click(function () {
            if ($('#company-details-form').valid()) {
                $('#company-details-form').submit();
            }
        });
    },

    showToolbar() {
        const nextButton = document.getElementsByClassName('sw-btn-next')[0];
        const finishButton = document.getElementById('finish-btn');
        nextButton.style.display = 'none';
        finishButton.style.display = 'block';

        const toolbar = document.getElementsByClassName('sw-toolbar-elm')[0];
        toolbar.hidden = false;
    }
};
